// ======================================================================
// File Name       : GroupSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import FormControlCustom from '../../components/formControl/FormControl';

class GroupSearch extends Component {
  render() {
    const { filterData, onInputChange, onPressEnter } = this.props;
    const { groupName } = filterData;
    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <div className="col-sm-12 margin-top-10 form-horizontal">
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>ユーザーグループ名</Col>
            <Col sm={7}>
              <FormControlCustom
                name="groupName"
                value={groupName}
                onChange={onInputChange}
                onEnter={onPressEnter}
              />
            </Col>
          </Form.Group>
        </div>
      </div>
    );
  }
}

GroupSearch.propTypes = {
  filterData: PropTypes.shape().isRequired,
  onInputChange: PropTypes.func,
  onPressEnter: PropTypes.func,
};

GroupSearch.defaultProps = {
  onInputChange: () => false,
  onPressEnter: () => false,
};

export default GroupSearch;
